import { Injectable } from '@angular/core';
import { ACCEPTED_STATUS, DossierSearchType, ofSearchType } from '@app/pcs/models';
import { PRODUCTION_ONLY } from '@app/pcs/models/dossier-search-agency-involvement';
import { TrainTypeService } from '@app/pcs/services/train-type.service';
import * as R from 'ramda';

@Injectable()
export class AdvancedSearchRequiredFieldsService {

  // Decision functions
  private requiredTrainType = (searchType) => searchType && ofSearchType([DossierSearchType.CARRY_FORWARD, DossierSearchType.BULK_RU_APPOINTMENT])(searchType);
  private requiredMyAcceptanceIndicator = (searchType) => searchType && ofSearchType([DossierSearchType.BULK_PERMANENT_ACCEPTANCE])(searchType);
  private requiredMyAgencyInvolvement = (searchType) => searchType && ofSearchType([DossierSearchType.BULK_RU_APPOINTMENT_PROCESSING])(searchType);
  private requiredAppointedAsRu = (searchType) => searchType && ofSearchType([DossierSearchType.BULK_RU_APPOINTMENT_PROCESSING])(searchType);

  private FIELDS_EXISTENCE = {
    trainType: this.requiredTrainType,
    myProgressStatuses: this.requiredMyAcceptanceIndicator,
    agencyInvolvement: this.requiredMyAgencyInvolvement,
    appointedAsRu: this.requiredAppointedAsRu
  };

  private FIELDS_DEFAULT_VALUES = {
    trainType: () => this.trainTypeService.getDefaultTrainTypeForUser(),
    myProgressStatuses: () => [ACCEPTED_STATUS],
    agencyInvolvement: () => PRODUCTION_ONLY,
    appointedAsRu: () => true
  };

  constructor(private trainTypeService: TrainTypeService) {
  }

  prepareRequiredFields(searchType) {
    let requiredFields = {};

    R.keys(this.FIELDS_EXISTENCE).forEach(key => {
      const shouldBeRequiredForSearchType = this.FIELDS_EXISTENCE[key].apply(this, [searchType]);
      if (shouldBeRequiredForSearchType) {
        const value = this.FIELDS_DEFAULT_VALUES[key].apply(this);
        requiredFields = R.mergeDeepRight(requiredFields, {
          [key]: value
        });
      }
    });

    return requiredFields;
  }
}
